<!-- Header -->
<tgx-onboarding-implementation-header [loggedUser]="loggedUser" [companyName]="companyName" [userImg]="userImg">
</tgx-onboarding-implementation-header>

<div class="container">
  <div class="section mt-5">
    <p class="section__title">Not so fast, we're working on it!</p>
    <div class="section__item border-bottom">
      <div class="row">
        <div class="col-12">
          <p class="xen-heading-4 mb-2">Integration status</p>
          <p class="section__item-subtit">Dear partner,</p>
          <p class="section__item-subtit">
            We are working on your integration. If you have any questions about how this process is going, do not
            hesitate to contact us.
          </p>
          <p class="section__item-subtit mb-4">
            Once the process is complete, return to this page to complete the onboarding and access the platform, thank
            you for your patience.
          </p>
          @if (!askContact) {
            <xen-btn
              [type]="'secondary'"
              [size]="'medium'"
              [label]="'Contact Travelgate'"
              [id]="'button id'"
              [full_width]="false"
              [icon]="true"
              [icon_placement]="'right'"
              [icon_snippet]="'far fa-arrow-right'"
              [disabled]="false"
              [loading]="false"
              [skin]="'blue'"
              (click)="sendSupportRequest('Seller')"
            ></xen-btn>
          }
        </div>
      </div>
    </div>
  </div>
</div>
